module.exports = __webpack_public_path__ + "img/m1.3342c35c.jpg";